import React, { useEffect, useState, useReducer, useCallback } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import { Table, Button, ButtonGroup, Collapse } from "react-bootstrap";
import Swal from "sweetalert2";
import { exportToExcel } from "react-json-to-excel";
import { Dropdown } from "rsuite";
import PageIcon from "@rsuite/icons/Page";
import MenuIcon from "@rsuite/icons/Menu";
import CharacterAuthorizeIcon from "@rsuite/icons/CharacterAuthorize";
import CalendarIcon from "@rsuite/icons/Calendar";
import EditIcon from "@rsuite/icons/Edit";
import EventDetailIcon from "@rsuite/icons/EventDetail";
import CloseOutlineIcon from "@rsuite/icons/CloseOutline";
import MinusRoundIcon from "@rsuite/icons/MinusRound";
import { FaPlus } from "react-icons/fa";
import { TiMinus } from "react-icons/ti";
import ModalCliente from "../components/sis/ModalCliente";
import ModalMarcaciones from "../components/sis/modalcliente/Vermarcaciones";
import ModalAsignarUsuario from "../components/sis/modalcliente/Asignarusuario";
import ModalAsignarUsuarioEdit from "../components/sis/modalcliente/Asignarusuarioedit";
import ModalPreviewCliente from "../components/sis/modalcliente/ModalPreviewCliente";
import ModalDescargaSesiones from "../components/sis/modalreportes/ModalDescargaSesiones";
import ModalCuentaApp from "../components/sis/modalcliente/ModalCuentaApp";
import ModalReceta from "../components/sis/modalcliente/ModalReceta";
import ModalUsoInsumo from "../components/sis/modalcliente/ModalUsoInsumo";
import ModalTarea from "../components/sis/modalcliente/ModalTarea";
import ModalHojaEnfermeria from "./paciente/ModalEnfermeria";
import {
  getPacientesById,
  updatePaciente,
  EstadoPaciente,
  updatecuentacliente,
  updateReceta,
  insertTarea,
  insertReceta,
  getRecetarioByPaciente,
  getUsoInsumosByPaciente,
  insertUsoInsumo,
  updateUsoInsumo,
  getTareaByPaciente,
  updateTarea,
  deleteTarea,
  deletePaciente,
} from "../../api/pacienteApi";
import { getAllUsuario, getUserCredentials } from "../../api/usuarioApi";
import { getLegajoByData, getLegajoByPaciente } from "../../api/marcacionApi";
import {
  getAsignacionByPaciente,
  insertAsignacion,
  updateAsignacion,
  delteAsignacion,
} from "../../api/profesionalPacienteApi";
import "./FichaCliente.css";
import { getAdminById } from "../../api/AdminApi";
import AuditHistoryPanel from "../components/sis/AuditHistoryPanel";

// Reducer for modals (adding new case for insumos modal)
const showReducer = (curShow, state) => {
  switch (state.type) {
    case "SHOW":
      return {
        isShow: true,
        typeModal: state.typeModal,
        onReturnValue: state.onReturnValue,
      };
    case "2":
      return {
        isShowAsignarUsuario: true,
        typeModal: state.typeModal,
        onReturnValue: state.onReturnValue,
      };
    case "3":
      return {
        isShowAsignarUsuarioEdit: true,
        typeModal: state.typeModal,
        onReturnValue: state.onReturnValue,
      };
    case "4":
      return {
        isShowDescargaMarcaciones: true,
        typeModal: state.typeModal,
        onReturnValue: state.onReturnValue,
      };
    case "5":
      return {
        isShowModalPDF: true,
        typeModal: state.typeModal,
        onReturnValue: state.onReturnValue,
      };
    case "CuentaApp":
      return {
        isShowModalCuentaApp: true,
        typeModal: state.typeModal,
        onReturnValue: state.onReturnValue,
      };
    case "Insumo":
      return {
        isShowModalInsumo: true,
        typeModal: state.typeModal,
        onReturnValue: state.onReturnValue,
      };
    case "END":
      return {
        ...curShow,
        isShow: false,
        isShowAsignarUsuario: false,
        isShowAsignarUsuarioEdit: false,
        isShowDescargaMarcaciones: false,
        isShowModalPDF: false,
        isShowModalCuentaApp: false,
        isShowModalInsumo: false,
      };
    default:
      return curShow;
  }
};

const FichaCliente = () => {
  const history = useHistory();
   const { id } = useParams(); // viene de la URL /Fichaclientes/:id

  // Permiso y loading
  const [loading, setLoading] = useState(true);
  const [hasPermission, setHasPermission] = useState(undefined);

  // Existing states
  const [items, setItems] = useState([]);
  const [defaultValue, setRow] = useState([]);
  const [listLegajo, setListLegajo] = useState([]);
  const [listProfesional, setListProfesional] = useState([]);
  const [originalList, setOriginalList] = useState([]);
  const [list, setList] = useState([]);
  const [edad, setEdad] = useState();
  const [colornivel, setColornivel] = useState();
  const [isColored, setIsColored] = useState("");
  const [type, setType] = useState("");
  const [estado, setEstado] = useState();
  const [activar, setActivar] = useState("");
  const [verMarcaciones, setVerMarcaciones] = useState(false);
  const [tareas, setTareas] = useState([]);
  const [recetas, setRecetas] = useState([]);
  const [showModalTarea, setShowModalTarea] = useState(false);
  const [showModalReceta, setShowModalReceta] = useState(false);
  const [tareaActual, setTareaActual] = useState(null);
  const [recetaActual, setRecetaActual] = useState(null);
  const [cliente] = useState("Profesional");
  const [nombrePaciente, setNombrePaciente] = useState("");
  // New state for insumos
  const [insumos, setInsumos] = useState([]);
  const [showModalInsumo, setShowModalInsumo] = useState(false);
  const [insumoActual, setInsumoActual] = useState(null);

  // Existing states for table expansion
  const [showMoreTareas, setShowMoreTareas] = useState(false);
  const [showMoreRecetas, setShowMoreRecetas] = useState(false);
  const [showMoreProfesionales, setShowMoreProfesionales] = useState(false);
  const [showMoreHistorial, setShowMoreHistorial] = useState(false);

  // New state for insumos table expansion
  const [showMoreInsumos, setShowMoreInsumos] = useState(false);

  // Existing states for card collapse
  const [openTareas, setOpenTareas] = useState(false);
  const [openRecetas, setOpenRecetas] = useState(false);
  const [openProfesionales, setOpenProfesionales] = useState(false);
  const [openHistorial, setOpenHistorial] = useState(false);

  // New state for insumos card collapse
  const [openInsumos, setOpenInsumos] = useState(false);

  const INITIAL_LIMIT = 5;

  // Reducer for modals
  const [reducer, dispatchReducer] = useReducer(showReducer, {
    isShow: false,
    isShowAsignarUsuario: false,
    isShowAsignarUsuarioEdit: false,
    isShowDescargaMarcaciones: false,
    isShowModalPDF: false,
    isShowModalCuentaApp: false,
    isShowModalInsumo: false,
    typeModal: null,
    onReturnValue: null,
  });

  const [showModalHoja, setShowModalHoja] = useState(false);

  const handleMostrarModalHoja = () => setShowModalHoja(true);
  const cerrarModalHoja = () => setShowModalHoja(false);

  // Existing modal handlers
  const handleShow = () => dispatchReducer({ type: "5" });
  const handleShowEdit = () =>
    dispatchReducer({ type: "SHOW", typeModal: "EDITAR" });
  const handleShowAU = () => dispatchReducer({ type: "2" });
  const handleShowAUE = (item) => {
    setRow(item);
    dispatchReducer({ type: "3" });
  };
  const handleCuentaApp = () => dispatchReducer({ type: "CuentaApp" });
  const onCloseModal = () => {
    dispatchReducer({ type: "END" });
    setVerMarcaciones(false);
  };

  // Existing task handlers
  const handleNuevaTarea = () => {
    setTareaActual(null);
    setShowModalTarea(true);
  };

  const editarTarea = (tarea) => {
    setTareaActual(tarea);
    setShowModalTarea(true);
  };

  const eliminarTarea = async (idtarea) => {
    try {
      Swal.fire({
        title: "Cargando Datos",
        allowOutsideClick: false,
        showCancelButton: false,
        showConfirmButton: false,
      });
      await deleteTarea(idtarea);
      const updatedTareas = await getTareaByPaciente(id);
      setTareas(updatedTareas);
      Swal.close();
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "No se pudo eliminar la tarea",
      });
    }
  };

  const guardarTarea = async (tarea) => {
    setShowModalTarea(false);
    try {
      Swal.fire({
        title: "Cargando Datos",
        allowOutsideClick: false,
        showCancelButton: false,
        showConfirmButton: false,
      });
      if (tarea.idtarea) {
        await updateTarea({ ...tarea, idpaciente: id });
      } else {
        await insertTarea({ ...tarea, idpaciente: id });
      }
      const updatedTareas = await getTareaByPaciente(id);
      setTareas(updatedTareas);
      Swal.close();
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "No se pudo guardar la tarea",
      });
    }
  };

  const cerrarModalTarea = () => setShowModalTarea(false);

  // Existing receta handlers
  const handleMostrarModalReceta = () => {
    setRecetaActual(null);
    setShowModalReceta(true);
  };

  const editarReceta = (receta) => {
    setRecetaActual(receta);
    setShowModalReceta(true);
  };

  const guardarReceta = async (receta) => {
    setShowModalReceta(false);
    try {
      Swal.fire({
        title: "Cargando Datos",
        allowOutsideClick: false,
        showCancelButton: false,
        showConfirmButton: false,
      });
      if (receta.idreceta) {
        await updateReceta({ ...receta, idpaciente: id });
      } else {
        await insertReceta({ ...receta, idpaciente: id });
      }
      const updatedRecetas = await getRecetarioByPaciente(id);
      setRecetas(updatedRecetas);
      Swal.close();
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "No se pudo guardar la receta",
      });
    }
  };

  const cerrarModalReceta = () => setShowModalReceta(false);

  // New insumo handlers
  const handleMostrarModalInsumo = () => {
    setInsumoActual(null);
    setShowModalInsumo(true);
  };

  const editarInsumo = (insumo) => {
    setInsumoActual(insumo);
    setShowModalInsumo(true);
  };

  const guardarInsumo = async (insumo) => {
    setShowModalInsumo(false);
    try {
      Swal.fire({
        title: "Cargando Datos",
        allowOutsideClick: false,
        showCancelButton: false,
        showConfirmButton: false,
      });
      if (insumo.idusoinsumo) {
        await updateUsoInsumo({ ...insumo, idpaciente: id });
      } else {
        await insertUsoInsumo({ ...insumo, idpaciente: id });
      }
      const updatedInsumos = await getUsoInsumosByPaciente(id);
      setInsumos(updatedInsumos);
      Swal.close();
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "No se pudo guardar el insumo",
      });
    }
  };

  const cerrarModalInsumo = () => setShowModalInsumo(false);

  // Existing delete patient handler
  const handleShowEliminar = () => {
    Swal.fire({
      title: "Eliminar Paciente",
      text: `¿Estás seguro que deseas eliminar al paciente ${items[0]?.NombrePaciente}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "Cancelar",
      confirmButtonText: "Sí, Eliminar",
    }).then((result) => {
      if (result.isConfirmed) {
        deletePaciente(id)
          .then(() => {
            Swal.fire("Eliminado", "Paciente eliminado.", "success");
            history.push("/clientes");
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: error.message || "No se pudo eliminar el paciente",
            });
          });
      }
    });
  };

  // Existing status change handler
  const estadousuarioCambiar = async () => {
    const { isConfirmed, value: motivo } = await Swal.fire({
      input: "textarea",
      inputLabel: "Motivo",
      showCancelButton: true,
      confirmButtonText: "Confirmar",
      cancelButtonText: "Cancelar",
    });
    if (isConfirmed) {
      try {
        await EstadoPaciente({ id, motivo });
        Swal.fire("Cambiado", "Estado actualizado.", "success");
        assigmentValue();
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: error.message || "No se pudo cambiar el estado",
        });
      }
    }
  };

  // Modified assigmentValue to include insumos
  const assigmentValue = useCallback(async () => {
    try {

      const resultUser = await getUserCredentials();
      const USERDATA = await getAdminById(resultUser.IdUsuario);
      setType(USERDATA[0].contacto);

      const result = await getPacientesById(id);
      setItems(result);
      setNombrePaciente(result[0].NombrePaciente);
      if (result[0].estaActivo === "Activo") {
        setEstado(true);
        setIsColored("green");
        setActivar("Inhabilitar");
      } else {
        setEstado(false);
        setIsColored("red");
        setActivar("Habilitar");
      }

      const resultFicha = await getLegajoByPaciente(id);
      setListLegajo(resultFicha);

      const resultProfesional = await getAsignacionByPaciente(id);
      setOriginalList(resultProfesional);
      setListProfesional(resultProfesional);

      const hoy = new Date();
      const cumpleanos = new Date(result[0].FechaNacimiento);
      let edadnow = hoy.getFullYear() - cumpleanos.getFullYear();
      const m = hoy.getMonth() - cumpleanos.getMonth();
      if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
        edadnow--;
      }
      setEdad(edadnow);

      setColornivel(
        result[0].nivel === "Nivel 1"
          ? "green"
          : result[0].nivel === "Nivel 2"
            ? "orange"
            : "red"
      );

      const recetas = await getRecetarioByPaciente(id);
      setRecetas(recetas);

      const tareas = await getTareaByPaciente(id);
      setTareas(tareas.sort((a, b) => new Date(b.fecha) - new Date(a.fecha)));

      // Load insumos
      const insumos = await getUsoInsumosByPaciente(id);
      setInsumos(insumos);


    } catch (error) {

      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "No se pudo cargar los datos",
      });
    }
  }, [id]);

  // Existing handlers (unchanged)
  const onReturnDataCliente = async (data) => {
    dispatchReducer({ type: "END" });
    try {
      await updatePaciente(data);
      Swal.fire({
        title: "Datos Actualizados",
        text: "Usuario del servicio actualizado correctamente",
        icon: "success",
      });
      assigmentValue();
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "No se pudo actualizar el paciente",
      });
    }
  };

  const onReturnupdateAsignacion = async (data) => {
    dispatchReducer({ type: "END" });
    try {
      await updateAsignacion(data);
      Swal.fire({
        title: "Asignación Actualizada",
        text: "Asignación actualizada correctamente",
        icon: "success",
      });
      assigmentValue();
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "No se pudo actualizar la asignación",
      });
    }
  };

  const eliminarAsignacion = async (data) => {
    Swal.fire({
      title: "Actualizar Asignación",
      text: `¿Estás seguro que deseas actualizar la asignación de ${data.UsuarioAsignado}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "Cancelar",
      confirmButtonText: "Sí, Cambiar",
    }).then((result) => {
      if (result.isConfirmed) {
        delteAsignacion(data.IdProfesionalPaciente)
          .then(() => {
            Swal.fire("Actualizado", "Asignación actualizada.", "success");
            assigmentValue();
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: error.message || "No se pudo actualizar la asignación",
            });
          });
      }
    });
  };

  const onReturnAsignarUsuario = async (data) => {
    dispatchReducer({ type: "END" });
    try {
      await insertAsignacion({
        ...data,
        idPaciente: id,
        NombrePaciente: items[0].NombrePaciente,
      });
      Swal.fire({
        title: "Profesional Asignado",
        text: "Asignado correctamente",
        icon: "success",
      });
      const result = await getAsignacionByPaciente(id);
      setListProfesional(result);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "No se pudo asignar el profesional",
      });
    }
  };

  const onGenerarComision = () => {
    history.push({
      pathname: "/Cierre",
      state: items[0],
    });
  };

  const handleMarcaciones = async () => {
    try {
      const resultUsuario = await getAllUsuario();
      const resultMapeado = resultUsuario.map((item) => ({
        label: `${item.Nombre} ${item.subtipo}`,
        value: item.IdUsuario,
      }));
      const newList = [{ label: "TODOS", value: "TODOS" }, ...resultMapeado];
      setList(newList);
      dispatchReducer({ type: "4" });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "No se pudo cargar los usuarios",
      });
    }
  };

  const generarReporte = async (data) => {
    dispatchReducer({ type: "END" });
    try {
      const listResult = await getLegajoByData({
        ...data,
        idPaciente: id,
        idUsuario: data.ID,
      });
      exportToExcel(listResult.legajo, "Reporte De Marcación");
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "No se pudo generar el reporte",
      });
    }
  };

  const updateCuentaApp = async (data1, data2, data3,data4) => {
    dispatchReducer({ type: "END" });
    try {
      await updatecuentacliente({ data1, data2, data3,data4});
      Swal.fire({
        title: "Datos de la Cuenta",
        text: "Actualizados correctamente",
        icon: "success",
      });
      assigmentValue();
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "No se pudo actualizar la cuenta",
      });
    }
  };

  const filtroAsignaciones = (data) => {
    if (data !== "TODOS") {
      setListProfesional(originalList.filter((num) => num.estado === data));
    } else {
      setListProfesional(originalList);
    }
  };

  useEffect(() => {
    assigmentValue();
  }, [assigmentValue]);
  useEffect(() => {
    const checkPermissionAndLoad = async () => {
      setLoading(true);
      try {
        const resultUser = await getUserCredentials();
        const USERDATA = await getAdminById(resultUser.IdUsuario);
        if (USERDATA?.usuarios === "false") {
          setHasPermission(false);
          setLoading(false);
          return;
        }
        setHasPermission(true);
      } catch (e) {
        setHasPermission(false);
      } finally {
        setLoading(false);
      }
    };
    checkPermissionAndLoad();
  }, []);
  useEffect(() => {
    if (hasPermission === true) {
      assigmentValue();
    }
  }, [hasPermission, assigmentValue]);
  // Existing groupByDate for tasks
  const groupByDate = (tareas) => {
    return tareas.reduce((acc, tarea) => {
      const fecha = tarea.fecha && tarea.fecha.trim() ? tarea.fecha : "Default";
      if (!acc[fecha]) {
        acc[fecha] = [];
      }
      acc[fecha].push(tarea);
      return acc;
    }, {});
  };
  // Ordenar fechas de forma descendente, colocando "sin-fecha" al final
  const groupedTareas = groupByDate(tareas);
  const sortedDates = Object.keys(groupedTareas).sort((a, b) => {
    if (a === "Default") return 1;
    if (b === "Default") return -1;
    return new Date(b) - new Date(a);
  });
  if (loading) {
    return (
      <div style={{
        minHeight: "60vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        zIndex: 2
      }}>
        <div style={{
          width: 38,
          height: 38,
          border: "4px solid #ddd",
          borderTop: "4px solid #1569c9ff",
          borderRadius: "50%",
          animation: "spin 1s linear infinite"
        }} />
        <span style={{ marginLeft: 14, color: "#444", fontSize: 18 }}>Cargando...</span>
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg);}
              100% { transform: rotate(360deg);}
            }
          `}
        </style>
      </div>
    );
  }
  if (hasPermission === false) {
    return (
      <div style={{ textAlign: "center", marginTop: 50 }}>
        <h3>No tiene permisos para ver esta información.</h3>
      </div>
    );
  }
  if (hasPermission !== true) {
    return null;
  }

  if (showModalHoja) {
    return (
      <ModalHojaEnfermeria
        estado={showModalHoja}
        onCloseModal={cerrarModalHoja}
        idpaciente={id}
        nombrePaciente={nombrePaciente}
        legajosPaciente={listLegajo}
      />
    );
  }

  return (
    <>
      {items.map((item) => (
        <div key={item.IdPacientes}>
          <div className="col-xl-12">
            <div className="page-titlesFichaClientes">
              <div className="row">
                <div className="col">
                  <h3 className="heading sm-mb-0">{item.NombrePaciente}</h3>
                  <span
                    className="heading sm-mb-0"
                    style={{ color: isColored }}
                  >
                    {item.estaActivo}
                  </span>
                  <span
                    className="m-2"
                    style={{ fontSize: "18px", color: "gray" }}
                    hidden={estado}
                  >
                    {item.motivo}
                  </span>
                </div>
                <div className="d-flex flex-row-reverse align-items-center flex-wrap col">
                  <Dropdown icon={<MenuIcon />} noCaret placement="leftStart">
                    <Dropdown.Item
                      icon={<CharacterAuthorizeIcon />}
                      onClick={handleShowAU}
                    >
                      Asignar Profesional
                    </Dropdown.Item>
                    <Dropdown.Item
                      icon={<EventDetailIcon />}
                      onClick={handleMostrarModalHoja}
                    >
                      Hoja de enfermería
                    </Dropdown.Item>

                    <Dropdown.Item
                      icon={<CalendarIcon />}
                      onClick={onGenerarComision}
                    >
                      Cierre
                    </Dropdown.Item>
                    <Dropdown.Item icon={<PageIcon />} onClick={handleShow}>
                      Ver PDF
                    </Dropdown.Item>
                    <Dropdown.Item icon={<EditIcon />} onClick={handleShowEdit}>
                      Editar
                    </Dropdown.Item>
                    <Dropdown.Item
                      icon={<EditIcon />}
                      onClick={handleCuentaApp}
                    >
                      Cuenta App
                    </Dropdown.Item>
                    <Dropdown.Item
                      icon={<MinusRoundIcon />}
                      onClick={estadousuarioCambiar}
                    >
                      {activar}
                    </Dropdown.Item>
                    <Dropdown.Item
                      icon={<CloseOutlineIcon />}
                      onClick={handleShowEliminar}
                    >
                      Eliminar
                    </Dropdown.Item>
                  </Dropdown>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-4 col-xxl-4">
              {type === "true" && (
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title">Contacto</h4>
                    <span style={{ fontSize: "18px", color: colornivel }}>
                      {item.nivel}
                    </span>
                  </div>
                  <div className="card-body p-4">
                    <strong>Facturación</strong>
                    <br />
                    <span>Razón Social: {item.RazonSocial}</span>
                    <br />
                    <span>RUC: {item.Ruc}</span>
                    <br />
                    <span>Tarifa: {item.tarifa}</span>
                    <br />
                    <span>Tiempo de Asistencia: {item.tiempoAsistencia}</span>
                    <br />
                    <strong>Encargado</strong>
                    <br />
                    <span>Nombre: {item.FamiliarResponsable}</span>
                    <br />
                    <span>CI: {item.CedulaResponsable}</span>
                    <br />
                    <span>Teléfono: {item.Celular}</span>
                    <br />
                    <strong>Otros</strong>
                    <br />
                    <span>Cómo conoció EethSA: {item.comoconocio}</span>
                    <br />
                    <span>Observación: {item.obs1}</span>
                    <br />
                  </div>
                </div>
              )}
            </div>
            <div className="col-xl-8 col-xxl-8">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Ficha</h4>
                </div>
                <div className="card-body p-4">
                  <strong>Datos Personales</strong>
                  <br />
                  <span>Fecha de Nacimiento: {item.FechaNacimiento}</span>
                  <br />
                  <span>Edad: {edad}</span>
                  <br />
                  <span>CI: {item.Cedula}</span>
                  <br />
                  <span>Teléfono: {item.Telefono}</span>
                  <br />
                  <span>Correo: {item.Correo}</span>
                  <br />
                  <span>Ciudad: {item.Ciudad}</span>
                  <br />
                  <span>Dirección: {item.Direccion}</span>
                  <br />
                  <strong>Datos Médicos</strong>
                  <br />
                  <span>Peso: {item.peso} Kg</span>
                  <br />
                  <span>Altura: {item.altura} m</span>
                  <br />
                  <span>Sexo: {item.Sexo}</span>
                  <br />
                  <span style={{ color: "red" }}>
                    Alergias a medicamentos: {item.alergiasamedicamentos}
                  </span>
                  <br />
                  <span style={{ color: "red" }}>
                    Alergias en general: {item.alergiasgral}
                  </span>
                  <br />
                  <span>Diagnóstico Médico: {item.diagnosticoMedico}</span>
                  <br />
                  <span>Enfermedad de base: {item.enfermedadBase}</span>
                  <br />
                  <span>Movilidad Propia: {item.movilidadPropia}</span>
                  <br />
                  <span>
                    Equipo de Rehabilitación: {item.equipoRehabilitacion}
                  </span>
                  <br />
                  <span>Forma de Alimentación: {item.formaAlimentacion}</span>
                  <br />
                  <span>Vía de Alimentación: {item.viadealimentacion}</span>
                  <br />
                  <span>Tiempo de Guardia: {item.Guardiahs}</span>
                  <br />
                  <span>Observación: {item.obs2}</span>
                  <br />
                </div>
              </div>
            </div>

            {/* Card de Tareas */}
            <div className="card">
              <div
                className="card-header collapsible-header"
                onClick={() => setOpenTareas(!openTareas)}
                style={{ cursor: "pointer" }}
              >
                <h4 className="card-title">Tareas</h4>
                <div>
                  <button
                    className="btn btn-primary me-2"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleNuevaTarea();
                    }}
                  >
                    Agregar Tarea
                  </button>
                  <Button
                    variant="link"
                    onClick={(e) => {
                      e.stopPropagation();
                      setOpenTareas(!openTareas);
                    }}
                  >
                    {openTareas ? <TiMinus /> : <FaPlus />}
                  </Button>
                </div>
              </div>
              <Collapse in={openTareas}>
                <div className="card-body p-4">
                  {sortedDates.map((fecha) => (
                    <div key={fecha} className="mb-4">
                      <h5 className="mb-3">
                        {fecha === "Default" ? "Default" : fecha}
                      </h5>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          gap: "15px",
                          overflowX: "auto",
                          paddingBottom: "10px",
                        }}
                      >
                        {(showMoreTareas
                          ? groupedTareas[fecha].sort((a, b) => {
                            if (!a.fecha || !b.fecha) return 0;
                            return new Date(a.fecha) - new Date(b.fecha);
                          })
                          : groupedTareas[fecha]
                            .sort((a, b) => {
                              if (!a.fecha || !b.fecha) return 0;
                              return new Date(a.fecha) - new Date(b.fecha);
                            })
                            .slice(0, INITIAL_LIMIT)
                        ).map((tarea, index) => (
                          <div
                            key={index}
                            style={{
                              background: "#fff",
                              border: "1px solid #dee2e6",
                              borderRadius: "8px",
                              padding: "15px",
                              width: "250px",
                              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "space-between",
                              flexShrink: 0,
                            }}
                          >
                            <div>
                              <strong>{tarea.tarea}</strong>
                              <p style={{ margin: "5px 0", color: "#6c757d" }}>
                                {tarea.fecha && tarea.fecha.trim()
                                  ? tarea.hora
                                  : tarea.hora}
                              </p>
                            </div>
                            <div style={{ display: "flex", gap: "10px" }}>
                              <button
                                className="btn btn-sm btn-warning"
                                onClick={() => editarTarea(tarea)}
                              >
                                Editar
                              </button>
                              <button
                                className="btn btn-sm btn-danger"
                                onClick={() => eliminarTarea(tarea.idtarea)}
                              >
                                Eliminar
                              </button>
                            </div>
                          </div>
                        ))}
                      </div>
                      {groupedTareas[fecha].length > INITIAL_LIMIT && (
                        <Button
                          variant="link"
                          onClick={() => setShowMoreTareas(!showMoreTareas)}
                          className="mt-3"
                        >
                          {showMoreTareas ? <TiMinus /> : <FaPlus />}
                          {showMoreTareas ? " Mostrar menos" : " Mostrar más"}
                        </Button>
                      )}
                    </div>
                  ))}
                  {sortedDates.length === 0 && (
                    <p className="text-muted">No hay tareas disponibles.</p>
                  )}
                </div>
              </Collapse>
            </div>

            {/* Card de Recetario */}
            <div className="card mt-4">
              <div
                className="card-header collapsible-header"
                onClick={() => setOpenRecetas(!openRecetas)}
                style={{ cursor: "pointer" }}
              >
                <h4 className="card-title">Recetario</h4>
                <div>
                  <button
                    className="btn btn-primary me-2"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleMostrarModalReceta();
                    }}
                  >
                    Agregar Receta
                  </button>
                  <Button
                    variant="link"
                    onClick={(e) => {
                      e.stopPropagation();
                      setOpenRecetas(!openRecetas);
                    }}
                  >
                    {openRecetas ? <TiMinus /> : <FaPlus />}
                  </Button>
                </div>
              </div>
              <Collapse in={openRecetas}>
                <div className="card-body p-4">
                  <Table responsive striped className="primary-table-bordered">
                    <thead className="thead-primary">
                      <tr>
                        <th style={{ width: "25%", whiteSpace: "nowrap" }}>
                          Medicamento
                        </th>
                        <th style={{ width: "12%", whiteSpace: "nowrap" }}>
                          Dosis
                        </th>
                        <th
                          style={{
                            width: "13%",
                            whiteSpace: "nowrap",
                            whiteSpace: "pre-wrap",
                            overflowWrap: "break-word",
                          }}
                        >
                          Cantidad Dosis
                        </th>
                        <th
                          style={{
                            width: "13%",
                            whiteSpace: "nowrap",
                            whiteSpace: "pre-wrap",
                            overflowWrap: "break-word",
                          }}
                        >
                          Cantidad Dosis Faltante
                        </th>
                        <th style={{ width: "22%", whiteSpace: "nowrap" }}>
                          Doctor
                        </th>
                        <th style={{ width: "10%", whiteSpace: "nowrap" }}>
                          Registro
                        </th>
                        <th style={{ width: "10%", whiteSpace: "nowrap" }}>
                          Opciones
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {(showMoreRecetas
                        ? recetas
                        : recetas.slice(0, INITIAL_LIMIT)
                      ).map((receta, index) => (
                        <tr key={index}>
                          <td>{receta.medicamento}</td>
                          <td>{receta.dosis}</td>
                          <td>{receta.cantdosis}</td>
                          <td>{receta.cantdosisactual}</td>
                          <td>{receta.doctor}</td>
                          <td>{receta.registro}</td>
                          <td>
                            <button
                              className="btn btn-sm btn-warning me-2"
                              onClick={() => editarReceta(receta)}
                            >
                              Editar
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  {recetas.length > INITIAL_LIMIT && (
                    <Button
                      variant="link"
                      onClick={() => setShowMoreRecetas(!showMoreRecetas)}
                      className="mt-3"
                    >
                      {showMoreRecetas ? <TiMinus /> : <FaPlus />}
                    </Button>
                  )}
                </div>
              </Collapse>
            </div>

            {/* Card de Uso de Insumos */}
            <div className="card mt-4">
              <div
                className="card-header collapsible-header"
                onClick={() => setOpenInsumos(!openInsumos)}
                style={{ cursor: "pointer" }}
              >
                <h4 className="card-title">Uso de Insumos</h4>
                <div>
                  <button
                    className="btn btn-primary me-2"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleMostrarModalInsumo();
                    }}
                  >
                    Agregar Insumo
                  </button>
                  <Button
                    variant="link"
                    onClick={(e) => {
                      e.stopPropagation();
                      setOpenInsumos(!openInsumos);
                    }}
                  >
                    {openInsumos ? <TiMinus /> : <FaPlus />}
                  </Button>
                </div>
              </div>
              <Collapse in={openInsumos}>
                <div className="card-body p-4">
                  <Table responsive striped className="primary-table-bordered">
                    <thead className="thead-primary">
                      <tr>
                        <th style={{ width: "25%", whiteSpace: "nowrap" }}>
                          Insumo
                        </th>
                        <th style={{ width: "12%", whiteSpace: "nowrap" }}>
                          Cantidad
                        </th>
                        <th
                          style={{
                            width: "13%",
                            whiteSpace: "nowrap",
                            whiteSpace: "pre-wrap",
                            overflowWrap: "break-word",
                          }}
                        >
                          Cantidad Total
                        </th>
                        <th
                          style={{
                            width: "13%",
                            whiteSpace: "nowrap",
                            whiteSpace: "pre-wrap",
                            overflowWrap: "break-word",
                          }}
                        >
                          Cantidad Actual
                        </th>
                        <th style={{ width: "22%", whiteSpace: "nowrap" }}>
                          Encargado
                        </th>

                        <th style={{ width: "10%", whiteSpace: "nowrap" }}>
                          Opciones
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {(showMoreInsumos
                        ? insumos
                        : insumos.slice(0, INITIAL_LIMIT)
                      ).map((insumo, index) => (
                        <tr key={index}>
                          <td>{insumo.insumo}</td>
                          <td>{insumo.cantidad}</td>
                          <td>{insumo.cantidadtotal}</td>
                          <td>{insumo.cantidadactual}</td>
                          <td>{insumo.encargado}</td>

                          <td>
                            <button
                              className="btn btn-sm btn-warning me-2"
                              onClick={() => editarInsumo(insumo)}
                            >
                              Editar
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  {insumos.length > INITIAL_LIMIT && (
                    <Button
                      variant="link"
                      onClick={() => setShowMoreInsumos(!showMoreInsumos)}
                      className="mt-3"
                    >
                      {showMoreInsumos ? <TiMinus /> : <FaPlus />}
                    </Button>
                  )}
                </div>
              </Collapse>
            </div>

            {/* Card de Usuarios Asignados */}
            <div className="card mt-4">
              <div
                className="card-header collapsible-header"
                onClick={() => setOpenProfesionales(!openProfesionales)}
                style={{ cursor: "pointer" }}
              >
                <h4 className="card-title">Usuarios Asignados</h4>
                <div>
                  <ButtonGroup className="me-2">
                    <Button
                      onClick={(e) => {
                        e.stopPropagation();
                        filtroAsignaciones("ACTIVO");
                      }}
                    >
                      Activos
                    </Button>
                    <Button
                      onClick={(e) => {
                        e.stopPropagation();
                        filtroAsignaciones("INACTIVO");
                      }}
                    >
                      Inactivos
                    </Button>
                    <Button
                      onClick={(e) => {
                        e.stopPropagation();
                        filtroAsignaciones("TODOS");
                      }}
                    >
                      Todos
                    </Button>
                  </ButtonGroup>
                  <Button
                    variant="link"
                    onClick={(e) => {
                      e.stopPropagation();
                      setOpenProfesionales(!openProfesionales);
                    }}
                  >
                    {openProfesionales ? <TiMinus /> : <FaPlus />}
                  </Button>
                </div>
              </div>
              <Collapse in={openProfesionales}>
                <div className="card-body p-4">
                  <Table responsive className="primary-table-bordered" striped>
                    <thead className="thead-primary">
                      <tr>
                        <th>Usuario</th>
                        <th>Guardia HS</th>
                        <th>Honorario</th>
                        <th>Modalidad</th>
                        <th>Estado</th>
                        <th>Balance</th>
                        <th>Opciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(showMoreProfesionales
                        ? listProfesional
                        : listProfesional.slice(0, INITIAL_LIMIT)
                      ).map((item, index) => (
                        <tr key={index}>
                          <td>{item.UsuarioAsignado}</td>
                          <td>{item.guardiahs}</td>
                          <td>{item.honorarioenfermero}</td>
                          <td>{item.Modalidad}</td>
                          <td
                            style={{
                              color: item.estado === "ACTIVO" ? "green" : "red",
                            }}
                          >
                            {item.estado}
                          </td>
                          <td>{item.balance}</td>
                          <td>
                            <button
                              className="btn btn-primary me-2"
                              onClick={() => handleShowAUE(item)}
                            >
                              Editar
                            </button>
                            <button
                              className="btn btn-danger"
                              onClick={() => eliminarAsignacion(item)}
                            >
                              Activar/Inactivar
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  {listProfesional.length > INITIAL_LIMIT && (
                    <Button
                      variant="link"
                      onClick={() =>
                        setShowMoreProfesionales(!showMoreProfesionales)
                      }
                      className="mt-3"
                    >
                      {showMoreProfesionales ? <TiMinus /> : <FaPlus />}
                    </Button>
                  )}
                </div>
              </Collapse>
            </div>

            {/* Card de Historial */}
            <div className="card mt-4">
              <div
                className="card-header collapsible-header"
                onClick={() => setOpenHistorial(!openHistorial)}
                style={{ cursor: "pointer" }}
              >
                <h4 className="card-title">Historial</h4>
                <div>
                  <Button
                    className="me-2"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleMarcaciones();
                    }}
                  >
                    Descargar Marcaciones
                  </Button>
                  <Button
                    variant="link"
                    onClick={(e) => {
                      e.stopPropagation();
                      setOpenHistorial(!openHistorial);
                    }}
                  >
                    {openHistorial ? <TiMinus /> : <FaPlus />}
                  </Button>
                </div>
              </div>
              <Collapse in={openHistorial}>
                <div className="card-body p-4">
                  <Table responsive className="primary-table-bordered" striped>
                    <thead className="thead-primary">
                      <tr>
                        <th>Usuario</th>
                        <th>Entrada</th>
                        <th>Entrada hs</th>
                        <th>Salida</th>
                        <th>Salida Hs</th>
                        <th>Cant. Hs</th>
                        <th>Horas Extra</th>
                        <th>Honorario</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(showMoreHistorial
                        ? listLegajo
                        : listLegajo.slice(0, INITIAL_LIMIT)
                      ).map((item, index) => (
                        <tr key={index}>
                          <td>
                            <Link to={`/fichausuario/${item.IdUsuario}`}>
                              {item.Usuario}
                            </Link>
                          </td>
                          <td>{item.Fecha}</td>
                          <td>{item.HoraEntrada}</td>
                          <td>{item.FechaSalida}</td>
                          <td>{item.HoraSalida}</td>
                          <td>{item.horascalculadas}</td>
                          <td>{item.horashoraextra}</td>
                          <td>
                            {Math.round(
                              item.horascalculadas * item.CostoHoraProfesional +
                              item.horashoraextra * item.CostoHoraProfesional
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  {listLegajo.length > INITIAL_LIMIT && (
                    <Button
                      variant="link"
                      onClick={() => setShowMoreHistorial(!showMoreHistorial)}
                      className="mt-3"
                    >
                      {showMoreHistorial ? <TiMinus /> : <FaPlus />}
                    </Button>
                  )}
                </div>
              </Collapse>
            </div>
            <AuditHistoryPanel
              scope="cliente"
              entityId={id}
              title="Gastos, cierres, anticipos y asistencias"
            />
          </div>
        </div>
      ))}
      {reducer.isShow && (
        <ModalCliente
          estado={reducer.isShow}
          typeModal={reducer.typeModal}
          onCloseModal={onCloseModal}
          idpaciente={items}
          onReturnValue={onReturnDataCliente}
        />
      )}
      {verMarcaciones && (
        <ModalMarcaciones
          estado={verMarcaciones}
          onCloseModal={onCloseModal}
          idpaciente={items}
        />
      )}
      {reducer.isShowAsignarUsuario && (
        <ModalAsignarUsuario
          estado={reducer.isShowAsignarUsuario}
          typeModal={reducer.typeModal}
          onCloseModal={onCloseModal}
          idpaciente={items}
          onReturnValue={onReturnAsignarUsuario}
        />
      )}
      {reducer.isShowAsignarUsuarioEdit && (
        <ModalAsignarUsuarioEdit
          estado={reducer.isShowAsignarUsuarioEdit}
          typeModal={reducer.typeModal}
          onCloseModal={onCloseModal}
          dataedit={defaultValue}
          onReturnValue={onReturnupdateAsignacion}
        />
      )}
      {reducer.isShowDescargaMarcaciones && (
        <ModalDescargaSesiones
          estado={reducer.isShowDescargaMarcaciones}
          onCloseModal={onCloseModal}
          onReturnValue={generarReporte}
          Lista={list}
          ClienteOCuenta={cliente}
        />
      )}
      {reducer.isShowModalPDF && (
        <ModalPreviewCliente
          estado={reducer.isShowModalPDF}
          onCloseModal={onCloseModal}
          onReturnValue={generarReporte}
          datos={items[0]}
        />
      )}
      {reducer.isShowModalCuentaApp && (
        <ModalCuentaApp
          estado={reducer.isShowModalCuentaApp}
          onCloseModal={onCloseModal}
          onReturnValue={updateCuentaApp}
          datos={items[0]}
        />
      )}
      {showModalTarea && (
        <ModalTarea
          estado={showModalTarea}
          onCloseModal={cerrarModalTarea}
          onReturnValue={guardarTarea}
          dataEdit={tareaActual}
        />
      )}
      {showModalReceta && (
        <ModalReceta
          estado={showModalReceta}
          onCloseModal={cerrarModalReceta}
          onReturnValue={guardarReceta}
          dataEdit={recetaActual}
        />
      )}
      {showModalInsumo && (
        <ModalUsoInsumo
          estado={showModalInsumo}
          onCloseModal={cerrarModalInsumo}
          onReturnValue={guardarInsumo}
          dataEdit={insumoActual}
        />
      )}
      {showModalHoja && (
        <ModalHojaEnfermeria
          estado={showModalHoja}
          onCloseModal={cerrarModalHoja}
          idpaciente={id}
          nombrePaciente={nombrePaciente}
          legajosPaciente={listLegajo}
        />
      )}

    </>
  );
};

export default FichaCliente;
